define.alias("shared/components/shared/upgrade/plan-highlight", "calendar/components/shared/upgrade/plan-highlight");